import React from 'react';
import { CourseOptionFilter } from '../../../types';
import { CourseOptionFilterType } from '../../../constants';
import { useDropdownMenu } from '../../../hooks';
import {
  Icon,
  Paragraph,
  StyledCardMenuPosition,
  StyledCardFilterItem,
  StyledOptionDisplayFilterItem,
} from '../../../styledComponents';
import { Menu } from '../../../dataComponents';

export type OptionDisplayFilterItemProps = {
  filterKey: CourseOptionFilterType;
  options: CourseOptionFilter[];
  label: string;
};

export function OptionDisplayFilterItem(props: OptionDisplayFilterItemProps) {
  const { filterKey, options, label } = props;

  const { ref, open, handleToggle, handleClose } = useDropdownMenu();

  return (
    <StyledOptionDisplayFilterItem ref={ref}>
      <StyledCardFilterItem onClick={handleToggle}>
        <Paragraph text={label} />
        <Icon matIcon={open ? 'expand_less' : 'expand_more'} />
      </StyledCardFilterItem>

      <StyledCardMenuPosition>
        <Menu
          open={open}
          filterKey={filterKey}
          items={options}
          onClose={handleClose}
        />
      </StyledCardMenuPosition>
    </StyledOptionDisplayFilterItem>
  );
}
